var map = {
	"./bedford/Home": 65312,
	"./broxbourne/Home": 66042,
	"./darlington/Home": 42056,
	"./defaults/Home": 97187,
	"./demo/Home": 67381,
	"./hull/Home": 47761,
	"./kirklees/Home": 92428,
	"./leicester/Home": 19848,
	"./northgate/Home": 51326,
	"./preston/Home": 25123,
	"./rushcliffe/Home": 19621,
	"./slough/Home": 19820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88626;